import { Link } from "react-router-dom";

function FeaturesSection() {
  return (
    <div className="w-full bg-white py-12 px-4 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {/* Feature 1 */}
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center mb-4">
              <svg
                className="w-12 h-12 text-amber-500"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5.14v14l11-7-11-7z" />
              </svg>
              <div className="ml-4">
                <h2 className="text-4xl font-bold text-amber-500">700+</h2>
                <p className="text-xl text-gray-800">Live classes monthly</p>
              </div>
            </div>
            <div className="w-full h-1 bg-amber-500 mb-4"></div>
            <p className="text-gray-700 text-center md:text-left">
              Featuring a global calendar led by industry experts
            </p>
          </div>

          {/* Feature 2 */}
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center mb-4">
              <svg
                className="w-12 h-12 text-blue-500"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z" />
              </svg>
              <div className="ml-4">
                <h2 className="text-4xl font-bold text-blue-500">550+</h2>
                <p className="text-xl text-gray-800">Learning solutions</p>
              </div>
            </div>
            <div className="w-full h-1 bg-blue-500 mb-4"></div>
            <p className="text-gray-700 text-center md:text-left">
              Role-based paths for AI and other digital skills, including
              industry certifications
            </p>
          </div>

          {/* Feature 3 */}
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center mb-4">
              <svg
                className="w-12 h-12 text-lime-500"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14l-5-5 1.41-1.41L12 14.17l4.59-4.58L18 11l-6 6z" />
              </svg>
              <div className="ml-4">
                <h2 className="text-4xl font-bold text-lime-500">100+</h2>
                <p className="text-xl text-gray-800">Projects & labs</p>
              </div>
            </div>
            <div className="w-full h-1 bg-lime-500 mb-4"></div>
            <p className="text-gray-700 text-center md:text-left">
              Real-world projects and integrated labs for AWS, Azure, and more
            </p>
          </div>
        </div>

        <div className="mt-12 flex justify-center">
          <Link to={'/login'}>
            <button className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-3 px-8 rounded-md transition-colors">
              Get A Free Trial
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default FeaturesSection;
